import { ResponseType } from "./Enums/ResponseType";

export class CandidateCampaignResponse {
  CandidateId?: string;
  CampaignId?: string;
  ResponseType?: ResponseType;
  ReferrerId?: string;
  ReferrerDetailId?: string;
  SubReferrerDetailId?: string;

  constructor(
    candidateId?: string,
    campaignId?: string,
    responseType?: ResponseType,
    referrerId?: string,
    referrerDetailId?: string,
    subReferrerDetailId?: string
  ) {
    this.CandidateId = candidateId;
    this.CampaignId = campaignId;
    this.ResponseType = responseType;
    this.ReferrerId = referrerId;
    this.ReferrerDetailId = referrerDetailId;
    this.SubReferrerDetailId = subReferrerDetailId;
  }
}
